import React, { FC }                from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown }                 from "semantic-ui-react";
import RecordTemplate               from "../../../../domain/record/template/RecordTemplate";
import RecordTemplateRepository     from "../../../../domain/record/template/RecordTemplateRepository";
import WidgetItem                   from "../../../../domain/record/widget/item/WidgetItem";
import WidgetItemId                 from "../../../../domain/record/widget/item/WidgetItemId";
import WidgetItems                  from "../../../../domain/record/widget/item/WidgetItems";
import WidgetItemTitle              from "../../../../domain/record/widget/item/WidgetItemTitle";
import WidgetItemValue              from "../../../../domain/record/widget/item/WidgetItemValue";
import Widget                       from "../../../../domain/record/widget/Widget";
import WidgetCoordinate             from "../../../../domain/record/widget/WidgetCoordinate";
import WidgetId                     from "../../../../domain/record/widget/WidgetId";
import Widgets                      from "../../../../domain/record/widget/Widgets";
import WidgetTitle                  from "../../../../domain/record/widget/WidgetTitle";
import WidgetType                   from "../../../../domain/record/widget/WidgetType";
import WidgetTypeClass              from "../../../../domain/record/widget/WidgetTypeClass";
import WidgetValue                  from "../../../../domain/record/widget/WidgetValue";
import { ResKaState }               from "../../../../index";
import RecordTemplateDataSource
                                    from "../../../../infrastructure/datasource/record/template/RecordTemplateDataSource";

const RecordTemplateDefaultSelector: FC = () => {
  const template: RecordTemplate = useSelector((state: ResKaState) => state.template);
  const repository: RecordTemplateRepository = new RecordTemplateDataSource(useDispatch());

  const karteWidgets: Widgets = new Widgets([
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.TEXT_AREA_SMALL),
      new WidgetCoordinate(0, 0),
      new WidgetTitle("主な症状"),
      new WidgetValue(),
      new WidgetItems()
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.TEXT_AREA_SMALL),
      new WidgetCoordinate(318, 0),
      new WidgetTitle("1. どのように発生したか"),
      new WidgetValue(),
      new WidgetItems()
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.CHECK_VERTICAL),
      new WidgetCoordinate(636, 0),
      new WidgetTitle("症状の発生"),
      new WidgetValue(),
      new WidgetItems([
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("急性"),
          new WidgetItemValue()
        ),
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("亜急性"),
          new WidgetItemValue()
        ),
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("慢性"),
          new WidgetItemValue()
        ),
      ])
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.CHECK_VERTICAL),
      new WidgetCoordinate(954, 0),
      new WidgetTitle("習慣"),
      new WidgetValue(),
      new WidgetItems([
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("アルコール"),
          new WidgetItemValue()
        ),
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("タバコ"),
          new WidgetItemValue()
        ),
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("レクリエーション薬"),
          new WidgetItemValue()
        ),
      ])
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.RADIO_VERTICAL),
      new WidgetCoordinate(1272, 0),
      new WidgetTitle("睡眠パターン"),
      new WidgetValue(),
      new WidgetItems([
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("3時間"),
          new WidgetItemValue()
        ),
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("5時間"),
          new WidgetItemValue()
        ),
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("7時間"),
          new WidgetItemValue()
        ),
      ])
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.TEXT_AREA_SMALL),
      new WidgetCoordinate(0, 194),
      new WidgetTitle("仮設診断"),
      new WidgetValue(),
      new WidgetItems()
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.CHECK_VERTICAL),
      new WidgetCoordinate(318, 194),
      new WidgetTitle("2. 痛み"),
      new WidgetValue(),
      new WidgetItems([
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("鋭い"),
          new WidgetItemValue()
        ),
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("鈍い"),
          new WidgetItemValue()
        ),
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("刺すような"),
          new WidgetItemValue()
        ),
      ])
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.TEXT_AREA_SMALL),
      new WidgetCoordinate(636, 194),
      new WidgetTitle("痛みはどれくらい深刻か"),
      new WidgetValue(),
      new WidgetItems()
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.TEXT_AREA_SMALL),
      new WidgetCoordinate(954, 194),
      new WidgetTitle("その他(習慣)"),
      new WidgetValue(),
      new WidgetItems()
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.TEXT_AREA_SMALL),
      new WidgetCoordinate(1272, 194),
      new WidgetTitle("その他(睡眠パターン)"),
      new WidgetValue(),
      new WidgetItems()
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.TEXT_AREA_SMALL),
      new WidgetCoordinate(0, 388),
      new WidgetTitle("禁忌／注意事項"),
      new WidgetValue(),
      new WidgetItems()
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.RADIO_VERTICAL),
      new WidgetCoordinate(318, 388),
      new WidgetTitle("3. 変更要因"),
      new WidgetValue(),
      new WidgetItems([
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("改善"),
          new WidgetItemValue()
        ),
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("悪化"),
          new WidgetItemValue()
        )
      ])
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.TEXT_AREA_SMALL),
      new WidgetCoordinate(636, 388),
      new WidgetTitle("変更理由"),
      new WidgetValue(),
      new WidgetItems()
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.CHECK_VERTICAL),
      new WidgetCoordinate(954, 388),
      new WidgetTitle("ストレス要因"),
      new WidgetValue(),
      new WidgetItems([
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("家庭環境"),
          new WidgetItemValue()
        ),
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("職場環境"),
          new WidgetItemValue()
        ),
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("人間関係"),
          new WidgetItemValue()
        ),
      ])
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.RADIO_VERTICAL),
      new WidgetCoordinate(1272, 388),
      new WidgetTitle("食生活"),
      new WidgetValue(),
      new WidgetItems([
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("偏っている"),
          new WidgetItemValue()
        ),
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("良い"),
          new WidgetItemValue()
        ),
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("普通"),
          new WidgetItemValue()
        ),
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("貧相"),
          new WidgetItemValue()
        )
      ])
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.TEXT_AREA_SMALL),
      new WidgetCoordinate(0, 616),
      new WidgetTitle("治療上の注意事項／治療上の変更"),
      new WidgetValue(),
      new WidgetItems()
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.TEXT_AREA_SMALL),
      new WidgetCoordinate(318, 616),
      new WidgetTitle("4. 関連症状"),
      new WidgetValue(),
      new WidgetItems()
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.TEXT_AREA_SMALL),
      new WidgetCoordinate(1272, 616),
      new WidgetTitle("その他(食生活)"),
      new WidgetValue(),
      new WidgetItems()
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.TEXT_AREA_SMALL),
      new WidgetCoordinate(954, 616),
      new WidgetTitle("その他(ストレス要因)"),
      new WidgetValue(),
      new WidgetItems()
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.TEXT_AREA_SMALL),
      new WidgetCoordinate(0, 793),
      new WidgetTitle("短期目標"),
      new WidgetValue(),
      new WidgetItems()
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.CHECK_VERTICAL),
      new WidgetCoordinate(318, 793),
      new WidgetTitle("5. 治療歴"),
      new WidgetValue(),
      new WidgetItems([
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("カイロプラクティック"),
          new WidgetItemValue()
        ),
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("病院"),
          new WidgetItemValue()
        ),
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("整体"),
          new WidgetItemValue()
        ),
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("マッサージ"),
          new WidgetItemValue()
        )
      ])
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.CHECK_VERTICAL),
      new WidgetCoordinate(636, 793),
      new WidgetTitle("6. 治療内容"),
      new WidgetValue(),
      new WidgetItems([
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("薬"),
          new WidgetItemValue()
        ),
        new WidgetItem(
          new WidgetItemId(),
          new WidgetItemTitle("手術"),
          new WidgetItemValue()
        )
      ])
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.TEXT_AREA_SMALL),
      new WidgetCoordinate(0, 970),
      new WidgetTitle("長期目標"),
      new WidgetValue(),
      new WidgetItems()
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.TEXT_BOX),
      new WidgetCoordinate(318, 1021),
      new WidgetTitle("その他(治療歴)"),
      new WidgetValue(),
      new WidgetItems()
    ),
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.TEXT_AREA_SMALL),
      new WidgetCoordinate(636, 952),
      new WidgetTitle("その他(治療内容)"),
      new WidgetValue(),
      new WidgetItems()
    ),
  ]);

  const widgetsA4: Widgets = new Widgets([
    new Widget(
      new WidgetId(),
      WidgetTypeClass.of(WidgetType.IMAGE_A4),
      new WidgetCoordinate(0, 0),
      new WidgetTitle("紙面記録"),
      new WidgetValue(),
      new WidgetItems()
    )
  ]);

  return (
    <>
      <Dropdown
        button
        className="icon"
        icon="file"
        floating
        labeled
        text="標準のフォーマットから選択する"
      >
        <Dropdown.Menu>
          <Dropdown.Item
            text="カイロプラクティックカルテ"
            onClick={ () => repository.setTemplate(new RecordTemplate(
              template.id,
              template.revision,
              template.name,
              karteWidgets
            )) }
          />
          <Dropdown.Item
            text="A4紙取り込み"
            onClick={ () => repository.setTemplate(new RecordTemplate(
              template.id,
              template.revision,
              template.name,
              widgetsA4
            )) }
          />
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default RecordTemplateDefaultSelector;
